interface ArrowDawnSvgProps {
  color?: string;
  width?: number | string;
  height?: number | string;
}

const ArrowDawnSvg = ({ color = "#2A2D31", width = 16, height = 16 }: ArrowDawnSvgProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33317 6.66699L7.99984 9.33366L10.6665 6.66699"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowDawnSvg;
